module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv12-d9dfcd9b5935d719f10b2f2f0c3bbe77.jpg";